<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" color="#fff" type="ball-climbing-dot">
  <p style="font-size: 20px; color: white">Caricamento...</p>
</ngx-spinner>
